import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import './SecretsModal.css';
import { modalInputClass } from './modalInputClass';
import { useModalSelectionGuard, preventModalOverlaySelection } from '../hooks/useModalSelectionGuard';

const formatAmount = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '-';
  return Number(num).toLocaleString('ru-RU', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
};

const CreateOrderConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  amount,
  futuresCount,
  actualCost,
  broker,
  stock,
  futures
}) => {
  useModalSelectionGuard(isOpen);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  useEffect(() => {
    if (!isOpen) return undefined;

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        handleCancel();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, handleCancel]);

  if (!isOpen) return null;

  const brokerLabel = broker === 'bcs' ? 'БКС' : broker === 'finam' ? 'Финам' : broker;

  return createPortal(
    <div className="secrets-modal-overlay secrets-modal-overlay--elevated" onSelectStart={preventModalOverlaySelection}>
      <div className="secrets-modal" onClick={e => e.stopPropagation()}>
        <div className="secrets-modal-header">
          <h2>Открыть сделку</h2>
          <button className="secrets-close-btn" onClick={handleCancel}>×</button>
        </div>

        <div className="secrets-form">
          <div className="form-group">
            <div className="secrets-modal-summary">
              {stock} / {futures}{' // '}{brokerLabel}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="createOrderAmount">Сумма заказа</label>
            <input
              type="text"
              id="createOrderAmount"
              value={`${formatAmount(amount)} ₽`}
              readOnly
              className={modalInputClass({ readonly: true })}
            />
          </div>

          <div className="form-group">
            <label htmlFor="createOrderFuturesCount">Количество фьючерсов</label>
            <input
              type="text"
              id="createOrderFuturesCount"
              value={String(futuresCount ?? '')}
              readOnly
              className={modalInputClass({ readonly: true })}
            />
          </div>

          <div className="form-group">
            <label htmlFor="createOrderActualCost">Фактическая стоимость</label>
            <input
              type="text"
              id="createOrderActualCost"
              value={`${formatAmount(actualCost)} ₽`}
              readOnly
              className={modalInputClass({ readonly: true })}
            />
          </div>

          <div className="secrets-modal-buttons">
            <button type="button" className="secrets-cancel-btn" onClick={handleCancel}>
              Отмена
            </button>
            <button type="button" className="secrets-save-btn" onClick={onConfirm}>
              Открыть
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default CreateOrderConfirmModal;
